export default {
  bs_app(state) {
    return state.bs_app
  }
}